// ブラウザのローカルストレージに保存する設定情報
// * アカウントの認証情報とは異なる

import {language} from '../../lib/language'

// backward compatibility
// accountからlocaleを移行するための処理
if (window.localStorage.getItem('account/locale')) {
    window.localStorage.setItem('preferences/locale', window.localStorage.getItem('account/locale'))
    window.localStorage.removeItem('account/locale')
}

function tmp_welcome() {
    if (window.localStorage.getItem('preferences/isWelcome') === null || window.localStorage.getItem('preferences/isWelcome') === "true") {
        return "true"
    } else {
        return "false"
    }
}

const state = {
    isWelcome: tmp_welcome(),
    locale: window.localStorage.getItem('preferences/locale') ? window.localStorage.getItem('preferences/locale') : language(window.navigator.language),
}

const getters = {
    isJapanese: state => state.locale === "ja",
    isEnglish: state => state.locale === "en"
}

const mutations = {
    setPreferences(state, pref) {
        if (pref.isWelcome !== undefined) {
            window.localStorage.setItem('preferences/isWelcome', pref.isWelcome)
            state.isWelcome = pref.isWelcome
        }
        if (pref.locale) {
            window.localStorage.setItem('preferences/locale', pref.locale)
            state.locale = pref.locale
        }
    },
}

const actions = {
 }

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
